
import {Vue, Component, Prop} from 'vue-property-decorator';
import Template from "@/views/system-management/template/index.vue";

@Component({ name: 'FactoryDeliveryNotePreview',
  components: {Template}
})
export default class extends Vue {
  @Prop({ required: true }) private factoryDeliveryNote: any;
}
